import { Listbox, Transition } from '@headlessui/react';
import { MalaPuscicaDol } from 'kzv-icons';
import { Fragment } from 'react';

export default function SelectInput({ options, label, placeholder, value, helperText, error, handleChange }) {
    return (
        <div className="w-full">
            <Listbox value={value} onChange={handleChange}>
                {({ open }) => (
                    <div className="space-y-1 relative">
                        {label && <Listbox.Label className="pl-4 text-brand font-semibold">{label}</Listbox.Label>}

                        <Listbox.Button className="relative w-full h-11 pl-4 pr-10 text-left bg-white rounded-3xl border border-gray-500 shadow-sm cursor-default focus:ring-brand focus:ring-2 focus:outline-none">
                            <span className="block truncate leading-none">
                                {value ? (
                                    options.find((o) => o.value === value)?.label
                                ) : (
                                    <span className="opacity-50 text-gray-500 text-sm">{placeholder}</span>
                                )}
                            </span>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                <MalaPuscicaDol
                                    className="w-5 h-5 text-gray-400"
                                    aria-hidden="true"
                                    style={{ strokeWidth: 1.5 }}
                                />
                            </span>
                        </Listbox.Button>
                        <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Listbox.Options
                                static
                                className="absolute w-full py-1 mt-1 overflow-auto bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none text-sm z-20"
                            >
                                {options.map((option, i) => (
                                    <Listbox.Option
                                        key={i}
                                        className={({ active }) =>
                                            `${
                                                active ? ' bg-brand-dull' : 'text-gray-900'
                                            } cursor-pointer select-none relative py-2 pl-2 pr-4`
                                        }
                                        value={option.value}
                                    >
                                        {({ selected }) => (
                                            <>
                                                <span
                                                    className={`${
                                                        selected ? 'font-medium' : 'font-normal'
                                                    } block truncate`}
                                                >
                                                    {option.label}
                                                </span>
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                )}
            </Listbox>
            {helperText && (
                <div className={`pl-4 mt-2 text-xs text-left ${error ? 'text-danger' : 'text-secondary'}`}>
                    {helperText}
                </div>
            )}
        </div>
    );
}
